<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="modal-content">

  <div class="modal-header">
    <h3 class="modal-title font">Informe de contabilización</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
    <form class="form-modal py-3" [formGroup]="formGroup">
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="anio">Año <span class="oblig">*</span></label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="anio" id="anio"
              placeholder="" matInput type="number" [min]="0" DirectDecimalNumber>
            <mat-error *ngIf="controlHasError('anio', 'required')">Campo obligatorio</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="aceptada">Aceptadas</label>
          <div class="custom-mat-field">
              <mat-checkbox formControlName="aceptada" color="primary"></mat-checkbox>
          </div>
        </div>
        <div class="col-sm flex-grow-1" *ngIf="canViewResource('AI-ENV-GEST') || canViewResource('AI-ENV-CONS')">
          <label for="registradas">Registradas</label>
          <div class="custom-mat-field">
              <mat-checkbox formControlName="registradas" color="primary"></mat-checkbox>
           </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer actions">
    <div class="note">* Campos Obligatorios</div>
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
        aria-label="Cancelar">Cancelar</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="generarInforme()" 
        aria-label="Guardar">Aceptar</button>
    </div>
  </div>
</div>
